export default[
    {
        path: '/dataList/shopData',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '门店数据',
            keepAlive: false
        }
    }
]